import * as React from 'react';
import Orders from './Orders.js';

const OrdersContainer = ()=>{
    return /*#__PURE__*/ React.createElement(Orders, null);
};
var OrdersContainer$1 = OrdersContainer;

export { OrdersContainer$1 as default };
//# sourceMappingURL=OrdersContainer.js.map
